export const DEFAULT_MAX_ROOMS = 3;

export const DEFAULT_MAX_GUESTS = 15;

export const SOLO_OCCUPANCY = { adults: 1, children: [] };
